import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
export const withRouter = (component: React.FC) => () => (
  <Router>
    {component({})}
  </Router>
)